export default __webpack_public_path__ + "static/media/rndblog.07d0951f.png";